export interface Enumeration {
  id: number;
  name: string;
}
